<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        outlined
        :color="color"
        class="ml-3"
      >
        <v-icon>{{ icon }}</v-icon><span v-if="edit === false">Temas</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title
        class="modal-header elevation-10"
      >
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white">mdi-window-close</v-icon>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col sm="6">
            <v-text-field
              label="Tema"
              name="nome"
              type="text"
              required
              v-model="payload.nome"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
       <v-card-text>
        <v-row>
          <v-col sm="6">
            <v-text-field
              label="Pontos"
              name="nome"
              type="number"
              required
              v-model="payload.pontos"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
       <v-card-text>
        <v-row>
          <v-col sm="6">
            <v-text-field
              label="Perguntas"
              name="nome"
              type="number"
              required
              v-model="payload.perguntas"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text>
        <v-row>
          <v-col sm="6">
            <v-text-field
              label="Imagem"
              name="nome"
              type="text"
              required
              v-model="payload.imagem"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <app-eixo-combobox :edit-value="object || payload ">

      </app-eixo-combobox>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="dialog = false">Fechar</v-btn>
        <v-btn color="info" outlined text @click="onConfirm">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { temaAPI } from '../API/temaAPI'
import AppEixoCombobox from './Combobox.vue'

export default {
  name: 'AppModalInsertTemas',
  props: {
    object: { type: Object, required: false },
    edit: { type: Boolean, required: false, default: false },
    icon: { type: String, required: true },
    color: { type: String, required: true }
  },
  components: {
    AppEixoCombobox
  },
  data () {
    return {
      payload: {},
      dialog: false
    }
  },
  watch: {
    object (val) {
    }
  },
  mounted () {
    if (this.object && this.edit === true) {
      this.payload = this.object
    }
  },
  methods: {
    onConfirm () {
      if (this.edit === true) {
        temaAPI.update(this.payload)

          .then(resp => {
            this.dialog = false
            this.$emit('on-save')
          })
          .catch()
      } else {
        temaAPI.create(this.payload)
          .then(resp => {
            this.dialog = false
            this.$emit('on-save')
          })
          .catch()
        this.payload = {}
      }
    }
  }
}
</script>
